const gradient = ['#1A2980', '#26D0CE'];
const gradientReducedOpacity = ['rgba(26, 41, 128, 0.5)', 'rgba(38, 208, 206, 0.5)'];

const colors = {
  background: 'black',
  text: 'white',
  disabled: '#b0b0b0',
  accent1: gradient[0],
  accent2: gradient[1],
  gradient,
  gradientReducedOpacity,
};

export default colors;
